import $ from 'jquery';
import {is_numeric, is_object} from '../../Helpers/js';

$.fn.timedLoader = function (options) {
  let timeout = 700,
    size = '',
    text = '';

  if (is_object(options)) {
    timeout = options.timeout || timeout;
    size = options.size || '';
    text = options.text;
  } else if (is_numeric(options)) {
    timeout = options;
  } else if (options === false) {
    timeout = false;
  }

  $(this).each(function (index, elm) {
    let $elm = $(elm);

    if ($elm.data('loaderTimeout') && timeout !== false) {
      return;
    }

    if (timeout === false) {
      clearTimeout($elm.data('loaderTimeout'));
      $elm.data('loaderTimeout', null);

      $elm.find('div.loader-overlay').remove();
      $elm.find('div.ui.active.loader').remove();
    } else {
      const showLoader = () => {
        if ($elm.find('.loader-overlay').length == 0) {
          let $loader = $('<div>').addClass('ui ' + size + ' active blue loader');
          if (text) {
            $loader.html(text);
          }
          $elm.append($('<div>').addClass('loader-overlay'));
          $elm.append($loader);
        }
      };
      if (timeout > 0) {
        var loaderTimeout = setTimeout(showLoader, timeout);
        $elm.data('loaderTimeout', loaderTimeout);
      } else {
        showLoader();
      }
    }
  });

  return this;
};
